module.exports = __webpack_public_path__ + "img/completed.65d199bf.svg";